import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-20 md:px-8 md:py-32">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-20">
          <div>
            <p className="font-label text-xs tracking-[0.3em] text-primary-500 md:text-sm">
              FAQ
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              常见问题
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于黑料地址镜像站、备用入口与防封备用的常见疑问，都在这里。如果仍然找不到答案，
              优先回来看一眼本页的最新更新即可。
            </p>
          </div>

          <div className="border-t border-background-300">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q} className="border-b border-background-300">
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ${
                        isOpen
                          ? "border-primary-500 bg-primary-500 text-background-50"
                          : "border-background-300 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="pb-6 pr-10 text-sm leading-relaxed text-foreground-700 md:text-base">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}